import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickCommunityBanner = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (goodsSno: number) => {
      logAnalyticsEvent({
        name: 'CLICK_COMMUNITY_BANNER',
        analytics: {
          GOODS_SNO: goodsSno,
        },
      });
    },
    [logAnalyticsEvent],
  );
};
